import { Box } from '@salecycle/ui-component-library';
import { TooltipWrapper } from '../style';

interface IProps {
  heading: string;
  description: string;
}

export const TooltipHtml = (props: IProps) => {
  return (
    <Box stackItems={true} padding="10px">
      <TooltipWrapper>
        <h4>{props.heading}</h4>
        <p>{props.description}</p>
      </TooltipWrapper>
    </Box>
  );
};
